import React, { useEffect, useState } from "react";
import OverviewSection from "./overview";
import UnitsSection from "./units";
import Breadcrumbs from "../../../reusebale/breadcrumbs";
import MaintenanceRequestSection from "../../home/maintainance-request";
import ReceivePayment from "../../home/receivePayment";
import LeaseTableSection from "../property-detail/leaseSection";
import ImageCarousel from "../property-detail/image-carousel";
import db from "../../../../db/index.json";
import BaseUrl from "../../../../constants/BaseUrl";
import MyLoader from "../../../reusebale/MyLoader";
import PropertyLoader from "../../../skeleton-loader/propety-detail";
import { useSelector } from "react-redux";

const MainSection = ({
  onBack,
  propertyId,
  onViewDetailsMaintain,
  onMaintainancePage,
  onCreateLease,
  toggleLeaseDetail,
  onLandlordTable,
}) => {
  const [allDetails, setAllDetails] = useState();
  const [merchantInfo, setMerchantInfo] = useState();
  const [loader, setLoader] = useState();
  const { properties } = db;

  const { loginSuccess } = useSelector((state) => state.auth);

  const GetPropertyDetails = () => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/property/getPropertyDetails/${propertyId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setLoader(false);
          setAllDetails(result.data);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => console.error(error));
  };

  const getMerchantInfo = (merchantId) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/merchant/getMerchantById/${merchantId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "success") {
          setMerchantInfo(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    if (allDetails?.merchantAccountId) {
      getMerchantInfo(allDetails?.merchantAccountId);
    }
  }, [allDetails?.merchantAccountId]);

  useEffect(() => {
    GetPropertyDetails();
  }, [propertyId]);

  return (
    <div className="mb-8">
      <div className="mt-6 w-full">
        <Breadcrumbs
          classes={`text-darkColor font-popinsSemiBold text-lg`}
          content={`PROP-${allDetails?._id?.slice(1, 10)}`}
          subheading="Property Details"
          onBack={onBack}
        />
      </div>
      {loader && <PropertyLoader />}
      {!loader && (
        <>
          <OverviewSection
            allDetails={allDetails}
            merchantInfo={merchantInfo}
          />
          <ImageCarousel allDetails={allDetails} />
          {/* <div className="flex flex-wrap justify-between mt-5">
          {properties.cardData.map((item, i) => (
            <InfoCards item={item} />
          ))}
        </div> */}

          <div className="flex justify-between mt-4">
            <div className="w-[49%]">
              <UnitsSection allDetails={allDetails} />
            </div>
            <div className="w-[49%]">
              <MaintenanceRequestSection
                propertyId={propertyId}
                onViewDetails={onViewDetailsMaintain}
                onMaintainanceTable={onMaintainancePage}
              />
            </div>
            {/* <div className="w-[49%]">
              <ReceivePayment handleLandlordTable={onLandlordTable}/>
            </div> */}
          </div>
          <LeaseTableSection
            propertyId={propertyId}
            createLease={onCreateLease}
            isViewDetails={toggleLeaseDetail}
          />
        </>
      )}
    </div>
  );
};

export default MainSection;
